import useSWR from 'swr';

import { useAppContext } from 'hooks/context/useAppContext';

import { TPortfolioImage } from 'types/portfolio';

type PortfolioImageResponse = {
  data: TPortfolioImage[];
};

export const usePortfolioImages = () => {
  const { config, publicUser } = useAppContext();
  const url = `${config.apiUrlV3}/web/portfolio_images?slug=${publicUser.slug}`;

  const { isLoading, error, data } = useSWR<PortfolioImageResponse>(url);

  return { isLoading, error, images: data?.data };
};
